<template>
    <div class="container storefront-container mx-auto">
<!--        {{ storefront_user }}-->
        <CreatePingModal
            :mentionableUsers="[]"
            :modalVisible="pingModalShown"
            v-on:modalHidden="onModalHidden"
            :userId="storefront_user.id"
            :prePopulatedMentionedUser="pingModalMentionedUser"
            :isStoreFront="true"
            :is-organization-post="false"
            :isPost="isModalForPost"
            :maxContentLength="5000"
        />

        <UploadModal
            :modalVisible="uploadModalShown"
            :modalType="uploadModalType"
            @uploadModalClosed="uploadModalClosed"
        />

        <Header
            :user="storefront_user"
            @showUploadModal="showUploadModal"
            :isOwnStorefront="isOwnStorefront"
        />

        <ViewAllRecommendedPros
            :modalVisible="prosModalShown"
            :pros="pros"
            v-on:modalHidden="prosModalHidden"
        />

        <!-- Start button section -->
        <div
            class="flex md:justify-start grid grid-cols-2 ml-48 sm:ml-0 lg:grid-cols-4 md:gap-x-12 -mt-56 sm:mt-4"
        >
            <div class="flex lg:col-span-1 lg:w-full w-1/2">
                <!-- TODO: Toggle if Company name or User's name based on account type -->
                <div class="absolute ml-8 lg:hidden name-box">
                    <h2 class="company-name text-xlg md:text-2xl">
                        {{ storefront_user.display_name }}
                    </h2>
                    <h2 class="company-name text-xlg md:text-2xl">
                        {{ storefront_user.org_name}}
                    </h2>
                    <CityState
                        :location="storefront_user.business_location"
                    />
                    <p class="flex text-xl pb-1">Job title</p>
                    <p class="flex text-l md:text-xl pb-1">
                        {{ subindustryString }}
                    </p>
                    <!-- <p>{{ storefront_user.subindustry.tag }}</p> -->
                    <!-- FIND out if this is needed -->
                    <button
                        v-if="false"
                        class="text-lg md:text-2xl ml-2 flex lg:hidden items-center"
                        type="button"
                        @click="visitProSite"
                        aria-label="Visit this pro's website"
                    >
                        <svg-vue
                            icon="link-solid"
                            title="Visit this Pro website"
                            class="fill-salesium-red w-6 h-6 md:w-7 md:h-7"
                        />
                    </button>
                </div>
                <div class="flex mt-6 sm:mt-0 -translate-x-12">
                    <ConnectButton
                        :status="connectionStatus"
                        v-on:connect="onConnect"
                        v-if="!isOwnStorefront && logged_in_user"
                        :saving="connectionSaving"
                        class="mt-20 sm:mt-0"
                    />
<!--                    <CallButton
                        v-on:call="onCall"
                        class="invisible"
                        v-if="!isOwnStorefront && logged_in_user"
                    />
                    -->
                    <PingButton
                        v-if="!isOwnStorefront && logged_in_user"
                        v-on:ping="onPing"
                        class="-ml-24 lg:hidden mt-20 mr-16"
                    />
                </div>
            </div>

            <div class="flex md:col-span-2 justify-start">
                <div class="hidden ml-5 md:ml-0 absolute lg:flex name-box">
                    <h2
                        class="company-name display-center text-lg md:text-2xl md:ml-0 lg:block left"
                    >
                        {{ storefront_user.display_name }} &nbsp; &nbsp;
                    </h2>
                    <h2 class="company-name text-lg md:text-2xl">
                        {{ storefront_user.org_name}}
                    </h2>
                    <CityState
                        :location="storefront_user.business_location"
                    />
                    <p class="flex italic display-center text-lg ml-6 mt-1">
                        {{ subindustryString }}
                    </p>
                </div>
<!--
                <CallButton class="hidden lg:flex" v-if="!isOwnStorefront && logged_in_user" />

                <span
                    class="border-l border border-salesium-grey-100 ml-5 mr-5 hidden lg:block"
                    v-if="!isOwnStorefront"
                ></span>
-->
                <PingButton
                    v-if="!isOwnStorefront && logged_in_user"
                    v-on:ping="onPing"
                    class="hidden lg:flex"
                />
                <p class="-ml-28 md:ml-0 left-0 invisible md:visible sm:w-full">
                    About me:
                    <span v-if="editingAbout">
                        <textarea
                                 rows="3"
                                 cols="60"
                                 maxlength="250"
                                 class="rounded-lg w-5/6 ml-4"
                                 placeholder="Enter the Bio for the Storefront page"
                                 v-model="storefront_user.about"
                        />
                        <button
                            type="button"
                            @click="submitAbout()"
                            class="flex mx-auto mt-11 pl-5 text-white storefront-btn-blue font-medium rounded-lg text-sm px-5 py-2.5 mr-7 mb-2 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                        >
                            <svg-vue
                                v-if="aboutSaving"
                                icon="loader"
                                title="Saving"
                            />
                    Save
                </button>
                    </span>
                    <span v-else>
                        {{ storefront_user.about ? storefront_user.about : "Coming Soon"}}
                    </span>
                    <a
                        v-if="isOwnStorefront"
                        class="flex ml-2"
                        @click="toggleEditingAbout()"
                    >
                        <svg-vue
                            v-if="!editingAbout"
                            icon="pencil-solid"
                            title="about icon"
                            class="w-5 h-5 fill-black"
                        />
                    </a>
                </p>
                <p class="-ml-28 md:ml-0 left-0 invisible md:visible sm:w-full"
                    v-if="!logged_in_user">
                    Login or Register to interact with this Pro, and reload this page. Your information will remain private.
                </p>
                <div
                    v-if="isOwnStorefront && logged_in_user"
                    class="flex justify-end w-1/2 gap-x-6 mr-6 sm:mr-0 mt-8"
                >
                    <button
                        v-if="isOwnStorefront"
                        class="bg-salesium-blue primary-btn rounded-lg px-4 lg:text-hint text-sm text-white mt-4 sm:-mt-2"
                        type="button"
                        @click="handleAddPostClick"
                    >
                        Post
                    </button>
                </div>
                <div v-if="!logged_in_user"
                     class="flex justify-end w-1/2 gap-x-6 mr-6 sm:mr-0 mt-8"
                >
                    <a
                        class="primary-btn rounded-lg px-4 text-white no-underscore"
                        type="button"
                        href="/login"
                        target="_blank"
                    >
                        Login/Register
                    </a>
                </div>
            </div>
        </div>
        <!-- End button section -->

        <!-- Start content section -->

        <div class="mt-8 grid grid-cols-4 gap-x-12 content-wrapper">
            <div class="lg:block hidden">
                <div></div>
                <Hours
                    :isOwnStorefront="isOwnStorefront"
                    :user="storefront_user"
                />
                <RecommendedProList
                    :recommendedProPicks="recommendedProPicks"
                    :pros="pros"
                    v-on:openAllFeaturedProsModal="openViewAllModal"
                />
                <MyOrganizations
                    :user="storefront_user"
                    :show_status="storefront"
                    :organizations="organizations.filter(org => org.status === 1)"
                    :header="orgheader"
                />
            </div>
            <div class="lg:col-span-2 col-span-4">
                <PostsList
                    :isOwnStorefront="isOwnStorefront"
                    :posts="unPinnedPosts"
                    :pinnedPosts="pinnedPosts"
                />
            </div>
            <div class="lg:block hidden">
                <Ad aspectRatio="2 / 3" :image="'/img/storefrontAd.png'" />
                    <div class="flex items-center mb-2">
                        <h3>Business Address</h3>
                        <div class="ml-4" v-if="this.walkinsWelcome">Come Visit Us!</div>
                        <a
                            v-if="isOwnStorefront"
                            class="flex ml-2"
                            @click="toggleEditingLocation()"
                        >
                            <svg-vue
                                icon="pencil-solid"
                                title="storefront icon"
                                class="w-5 h-5 fill-black"
                            />
                        </a>
                    </div>

                    <div v-if="editingLocation">
                        <span> <t-checkbox name="options" v-model="walkinsWelcome" /> Walkins Welcome</span>
                            <Location :showTitle="false"
                                location-type="Business"
                                :location="businessLocationData"
                                @locationUpdated="updateLocation"
                            />
                    </div>
                    <span v-else>
                        <span v-if="walkinsWelcome">
                            {{ businessLocationData.address1 }},
                            <span v-if="businessLocationData.address2">
                            {{ businessLocationData.address2 }},
                            </span>
                        </span>
                        {{ businessLocationData.city }},
                        {{ businessLocationData.state_province }},
                        {{ businessLocationData.country_code }},
                        {{ businessLocationData.postal_code }}
                    </span>
                    <button
                        class="btn primary-btn m-2"
                        v-if="editingLocation"
                        @click="submitLocation"
                    >
                        <svg-vue
                            v-if="locationSaving"
                            icon="loader"
                            title="Loading"
                        />
                        Submit
                    </button>
                <div v-if="leafletData && walkinsWelcome">
                    <Leaflet
                            :lat="leafletData.lat"
                            :lng="leafletData.lng"
                            :zoom=16
                            :width="parseInt(284)"
                            :height="parseInt(300)"
                    />
                </div>
            </div>
        </div>
        <!-- End content section -->
    </div>
</template>

<script>
import Header from "./partials/Header.vue";
import RecommendedProList from "./partials/RecommendedProList.vue";
import Ad from "../Utils/Ad.vue";
import PostsList from "./partials/PostsList.vue";
import ConnectButton from "./partials/ConnectButton.vue";
import CallButton from "./partials/CallButton.vue";
import PingButton from "./partials/PingButton.vue";
import CouponButton from "./partials/CouponButton.vue";
import MyBlogButton from "./partials/MyBlogButton.vue";
import FilterButton from "../Utils/FilterButton.vue";
import Hours from "./partials/Hours.vue";
import CreatePingModal from "../Ping/CreatePingModal.vue";
import UploadModal from "./partials/UploadModal.vue";
import Leaflet from "../Location/Leaflet.vue";
import CityState from "../Utils/CityState.vue";
import Location from "../Location/Index.vue";
import ViewAllRecommendedPros from "./partials/ViewAllRecommendedPros.vue";
import MyOrganizations from "../Dashboard/partials/MyOrganizations.vue";
export default {
    data() {
        return {
            recommendedProPicks: [],
            hours: {},
            pingModalShown: false,
            shareModalShown: false,
            pingModalMentionedUser: null,
            shareModalMentionedUser: null,
            connectedData: this.connected,
            connectionSaving: false,
            isOwnStorefront: this.editable,
            isModalForPost: false,
            uploadModalShown: false,
            uploadModalType: "avatar",
            businessHoursArray: [],
            prosModalShown: false,
            editingLocation: false,
            editingAbout: false,
            locationSaving: false,
            aboutSaving: false,
            walkinsWelcome: this.storefront_user.walkins_welcome,
            businessLocationData: this.storefront_user.business_location? this.storefront_user.business_location : null,
            leafletData: {
                lat: this.storefront_user.business_location.lat ? parseFloat(this.storefront_user.business_location.lat) : parseFloat(this.storefront_user.business_location.latitude),
                lng: this.storefront_user.business_location.lng ? parseFloat(this.storefront_user.business_location.lng) : parseFloat(this.storefront_user.business_location.longitude)
            },
            orgheader: "Organizations",
            storefront: "storefront",
        };
    },
    props: [
        "storefront_user",
        "editable",
        "connected",
        "logged_in_user",
        "connection_ping_id",
        "posts",
        "pros",
        "organizations",
    ],
    computed: {
        connectionStatus() {
            if (this.connectedData === true) {
                return "Already Connected";
            } else if (this.connectedData == "pending") {
                return "Pending";
            } else if (this.connectedData == "waiting") {
                return "Accept pending request";
            } else {
                return "Connect";
            }
        },
        pinnedPosts() {
            return this.posts
                .filter((post) => post.is_pinned == true)
                .reverse();
        },
        unPinnedPosts() {
            return this.posts
                .filter((post) => post.is_pinned != true)
                .reverse();
        },
        subindustryString() {
            if (this.storefront_user.subindustry != null) {
                return this.storefront_user.subindustry.tag
                    .replaceAll("_", " ")
                    .substring(1);
            } else {
                return " ";
            }
        },
    },
    methods: {
        onConnect() {
            this.connectionSaving = true;
            if (this.connectionStatus == "Connect") {
                axios
                    .post(
                        "/api/connections/" +
                            this.storefront_user.id +
                            "/connectionRequest"
                    )
                    .then((response) => {
                        this.connectionSaving = false;
                        if (response.data.message === "Connection Requested") {
                            this.connectedData = "pending";
                        }
                        if (response.data.message === "Already Connected") {
                            this.connectedData = true;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            } else if (this.connectionStatus == "Accept pending request") {
                axios
                    .post(
                        "/api/pings/" +
                            this.connection_ping_id +
                            "/acceptConnection"
                    )
                    .then((response) => {
                        this.connectionSaving = false;
                        this.connectedData = true;
                    })
                    .catch((error) => {
                        console.log(error);
                        alert("Something went wrong!");
                    });
            }
        },
        onCall() {
            // TODO: implement call functionality
        },
        onPing() {
            this.isModalForPost = false;
            this.pingModalMentionedUser = this.storefront_user;
            this.pingModalShown = true;
        },
        showUploadModal(uploadType) {
            this.uploadModalType = uploadType;
            this.uploadModalShown = true;
        },
        showShareModal( member){
            this.shareModalMentionedUser = member;
            this.sharingMember = true;
            this.isModalForPost = false;
            this.shareModalShown = true;
        },
        onModalHidden(reloadFeed, showCareScoreSurvey) {
            this.pingModalShown = false;
            if (showCareScoreSurvey) {
                this.$dialog.show("careScore-dialog");
            }
        },
        uploadModalClosed() {
            this.uploadModalShown = false;
        },
        handleAddPostClick() {
            this.isModalForPost = true;
            this.pingModalShown = true;
        },
        openViewAllModal() {
            this.prosModalShown = true;
        },
        prosModalHidden() {
            this.prosModalShown = false;
        },
        submitLocation(){
            this.locationSaving = true;
            axios.put(`/api/locations/business/${this.storefront_user.id}`,{
                walkins_welcome: this.walkinsWelcome,
                business_location: this.businessLocationData,
            })
                    .then((response) => {
                        this.leafletData.lat = response.data.data[0];
                        this.leafletData.lng = response.data.data[1];
                        this.locationSaving = false;
                        this.$toasted.global.toast_success('Location updated successfully!');
                        this.editingLocation = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        alert("something went wrong!")
                    });
        },
        toggleEditingLocation(){
            this.editingLocation = !this.editingLocation;
        },
        toggleEditingAbout(){
            this.editingAbout = !this.editingAbout;
        },
        updateLocation(newLocation){
            this.businessLocationData = newLocation;
        },
        async submitAbout() {
            this.aboutSaving = true;
            this.editingAbout = false;
            await axios
                .post("/api/user", {
                    about: this.storefront_user.about
            })
                .then((response) => {
                    this.aboutSaving = false;
                    this.$toasted.global.toast_success('Save Successful');
                })
                .catch((error) => {
                    console.log(error);
                    alert("something went wrong!");
                });
        }
    },
    components: {
        Location,
        CityState,
        Leaflet,
        ViewAllRecommendedPros,
        Header,
        RecommendedProList,
        Ad,
        PostsList,
        ConnectButton,
        CallButton,
        PingButton,
        CouponButton,
        MyBlogButton,
        FilterButton,
        Hours,
        CreatePingModal,
        UploadModal,
        MyOrganizations,
    },
    mounted() {
//        console.log( this.storefront_user.org_name);
        console.log( this.organizations);
    },
};
</script>

<style scoped>
.button-row {
    margin-top: -25px;
}

.name-box {
    margin-top: -3rem;
    z-index: -1;
}

.pro-link-button svg {
    margin-top: 2px;
}

.storefront-container {
    max-width: 1690px !important;
}
</style>
